<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="mt-3 mb-3">
        <div class="card border-0">
          <a id="{{aPanelData.name}}"></a>
            <div [ngSwitch]="aPanelData.type">
              <div *ngSwitchCase="'block'">
                <div [innerHTML]="app.bypassHtmlSanitizing(aPanelData.content)"></div>
              </div>
              <div *ngSwitchDefault>
                <manager-wgt [aWidgetParams]="aPanelData"></manager-wgt>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>